export { default } from "./ProcessingUserAccesses";



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/index.js